import request from 'ykd-base/request'
import ProductOrder from '@/model/product/productOrder'

import { PayProduct } from '@/model/product/productOrder'
import { DeleteProductOrderParam } from '@/model/product/productOrder'
import PayResult from '@/model/product/payResult'
import RefundRequest from '@/model/product/refundRequest'

import PayOrder from '@/model/product/payOrder'
import Page from '@/model/common/page'

//添加一条订单
export async function saveProductOrder(
  payProductParam: PayProduct
): Promise<ProductOrder> {
  const res = await request<ProductOrder>({
    method: 'POST',
    biz: 'done',
    url: '/productorder/add',
    data: payProductParam
  })
  return res && res.data
}

//支付
export async function pay(payProductParam: PayProduct): Promise<PayResult> {
  const res = await request<PayResult>({
    method: 'POST',
    biz: 'done',
    url: '/productorder/pay',
    data: payProductParam
  })
  return res && res.data
}
//获取我的所有订单
export async function queryMyOrder(
  accountId: string,
  orderNumber: string,
  orderId: string,
  isOrder: boolean
): Promise<ProductOrder[]> {
  const res = await request<ProductOrder[]>({
    method: 'GET',
    biz: 'done',
    url: '/productorder/query',
    params: {
      accountId: accountId,
      orderNumber: orderNumber,
      orderId: orderId,
      isOrder: isOrder
    }
  })
  return res && res.data
}
//判断是否有未支付的订单
export async function queryWaitBuyerPay(
  accountId: string
): Promise<ProductOrder[]> {
  const res = await request<ProductOrder[]>({
    method: 'GET',
    biz: 'done',
    url: '/productorder/querywaitbuyerpay',
    params: {
      accountId: accountId
    }
  })
  return res && res.data
}
//删除订单

export async function deleteProductOrder(
  param: DeleteProductOrderParam
): Promise<boolean> {
  const res = await request<boolean>({
    method: 'POST',
    biz: 'done',
    url: '/productorder/delete',
    data: param
  })
  return res.isSuccess
}
//退款
export async function refundOrder(param: RefundRequest) {
  const res = await request({
    method: 'POST',
    biz: 'done',
    url: '/refund/refundorder',
    data: param
  })
  return res.isSuccess
}

export async function queryPayOrder(
  payOrderParam: any
): Promise<Page<PayOrder>> {
  const res = await request<Page<PayOrder>>({
    method: 'POST',
    biz: 'done',
    url: '/productorder/querypayorder',
    data: payOrderParam
  })
  return res.data
}

//下载
export async function downloadOrder(payOrderParam: any) {
  const res = await request({
    method: 'POST',
    biz: 'done',
    url: '/productorder/download',
    data: payOrderParam
  })
  return res.data
}
//开通课程

export async function activationCourse(activationCourseParam: any) {
  const res = await request({
    method: 'POST',
    biz: 'done',
    url: '/productorder/activationcourse',
    data: activationCourseParam
  })
  return res
}

export async function queryWxOrder(
  orderId: string
): Promise<any> {
  const res = await request<any>({
    method: 'GET',
    biz: 'done',
    url: '/pay/query/wxorder',
    params: {
      orderId: orderId
    }
  })
  return res;
}
